// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-356cc396]{position:absolute;z-index:10;left:-460px;width:460px;padding:20px 20px 45px 20px}section div[data-v-356cc396]{font-size:13px;margin-bottom:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
